import { render, staticRenderFns } from "./WriterPaid.pug?vue&type=template&id=cb68d1b4&external"
import script from "./WriterPaid.js?vue&type=script&lang=js&external"
export * from "./WriterPaid.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports